import {
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@mui/material";

export default function MultiSelectCheckbox({
  label = "Select",
  options = [],
  value = [], // array of selected _id values
  onChange,
  width = 300,
}) {
  const handleChange = (event) => {
    const newValue = event.target.value;

    // MUI sometimes returns a string with autofill
    const normalized =
      typeof newValue === "string" ? newValue.split(",") : newValue;

    onChange?.(normalized);
  };

  const isChecked = (id) => value.indexOf(id) > -1;

  return (
    <FormControl
      sx={{
        width: "80%",
        mb: 1,
      }}
    >
      <InputLabel>{label}</InputLabel>

      <Select
        multiple
        value={value}
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) =>
          options
            .filter((o) => selected.includes(o._id))
            .map((o) => o.name)
            .join(", ")
        }
      >
        {options.map((option) => (
          <MenuItem key={option._id} value={option._id}>
            <Checkbox checked={isChecked(option._id)} />
            <ListItemText primary={option.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
